module.exports = "/images/Digitalseller.png?f258112eea1c598b22fd12c793c0f0ad";